import { useSyncExternalStore } from "react";
import { useServerContext } from "./vite/one-server-only";
var clientMatches = [];
var clientMatchesListeners = /* @__PURE__ */ new Set();
function subscribeToClientMatches(callback) {
  clientMatchesListeners.add(callback);
  return function() {
    return clientMatchesListeners.delete(callback);
  };
}
function getClientMatchesSnapshot() {
  return clientMatches;
}
function setClientMatches(matches) {
  clientMatches = matches;
  queueMicrotask(function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = clientMatchesListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var listener = _step.value;
        listener();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  });
}
function updateMatchLoaderData(routeId, loaderData) {
  clientMatches = clientMatches.map(function(m) {
    return m.routeId === routeId ? {
      ...m,
      loaderData
    } : m;
  });
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = clientMatchesListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var listener = _step.value;
      listener();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
function useMatches() {
  var serverContext = useServerContext();
  if (process.env.VITE_ENVIRONMENT === "ssr") {
    var _ref;
    return (_ref = serverContext === null || serverContext === void 0 ? void 0 : serverContext.matches) !== null && _ref !== void 0 ? _ref : [];
  }
  var clientStoreMatches = useSyncExternalStore(
    subscribeToClientMatches,
    getClientMatchesSnapshot,
    // server snapshot for hydration - must match what SSR rendered
    function() {
      var _ref2;
      return (_ref2 = serverContext === null || serverContext === void 0 ? void 0 : serverContext.matches) !== null && _ref2 !== void 0 ? _ref2 : [];
    }
  );
  return clientStoreMatches;
}
function useMatch(routeId) {
  var matches = useMatches();
  return matches.find(function(m) {
    return m.routeId === routeId;
  });
}
function usePageMatch() {
  var matches = useMatches();
  return matches[matches.length - 1];
}
export {
  getClientMatchesSnapshot,
  setClientMatches,
  subscribeToClientMatches,
  updateMatchLoaderData,
  useMatch,
  useMatches,
  usePageMatch
};
//# sourceMappingURL=useMatches.js.map
